// src/i18n/locales/index.ts
// ChessMaestro.ai - Locale exports

import it from './it.json';
import en from './en.json';
import es from './es.json';
import de from './de.json';
import fr from './fr.json';
import ru from './ru.json';

export const resources = {
  it: { translation: it },
  en: { translation: en },
  es: { translation: es },
  de: { translation: de },
  fr: { translation: fr },
  ru: { translation: ru },
};

export { it, en, es, de, fr, ru };